import axios, { AxiosError, AxiosResponse } from 'axios';
import { CommandResult, GenericErrorResponse } from 'common/genericTypes';
import { Dispatch } from 'redux';
import { v4 as uuid } from 'uuid';
import qs from 'qs';
import { endLoading, startLoading } from 'store/modules/loader';

interface RequestConfig {
  api: string;
  catalogApi: string;
  repositorioApi: string;
}

export const requestConfig: RequestConfig = {
  api: process.env['REACT_APP_API_BASE_URL'] || '',
  catalogApi: process.env['REACT_APP_API_BASE_URL'] || '',
  repositorioApi: process.env['REACT_REPOSITORIO_API_BASE_URL'] || '',
};

export const axiosInstance = axios.create({
  baseURL: requestConfig.api,
  headers: {
    Authorization: `bearer ${sessionStorage.getItem('jwtToken') ?? sessionStorage.getItem('globalJwtToken')}`
  },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const catalogAxiosInstance = axios.create({
  baseURL: requestConfig.catalogApi,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export async function request<T>(
  axiosRequest: () => Promise<AxiosResponse<T>>,
  dispatch: Dispatch,
  errorDescription?: string,
  stackRequest: boolean = false
): Promise<T> {
  axiosInstance.interceptors.request.use((config) => {
    config.headers = {
      Authorization: `bearer ${sessionStorage.getItem('jwtToken') ?? sessionStorage.getItem('globalJwtToken')}`,
    };
    return config;
  });

  const requestId = uuid();

  try {
    if (stackRequest) dispatch(startLoading(requestId));

    const result = await axiosRequest();

    if (stackRequest) dispatch(endLoading(requestId));

    return result.data;
  } catch (error: any) {
    if (stackRequest) dispatch(endLoading(requestId));

    if (error.response?.status === 401) {
      if (sessionStorage.getItem('jwtToken')) {
        dispatch({
          type: 'snackBar/ADD',
          payload: {
            severity: 'sessionExpired',
            message: 'Sua sessão expirou, por favor faça login novamente.',
          },
        });
      } else {
        dispatch({
          type: 'snackBar/ADD',
          payload: {
            severity: 'error',
            message: error.response?.data?.message ?? 'Usuário e/ou senha inválidos.',
          },  
        });
      }
    }
    if (error.response?.data && error.response?.data?.message) {
      // Se o response tem 'itens' ou 'erros', o caller vai tratar a mensagem (endpoints de lote)
      if (!error.response.data.itens && !error.response.data.erros) {
        const commandResult = error.response.data as CommandResult;
        dispatch({
          type: 'snackBar/ADD',
          payload: {
            severity: 'error',
            message: commandResult.message,
          },
        });
      }
    } else if (error.response) {
      if (error.response.data && Array.isArray(error.response.data.errors)) {
        const commandResult = error.response.data as CommandResult;
        dispatch({
          type: 'snackBar/ADD',
          payload: {
            severity: 'error',
            message: commandResult.errors.join(', '),
          },
        });
      } else if (!error.response.data?.erros) {
        const axiosError = error as AxiosError<GenericErrorResponse>;
        const message: any = axiosError.response?.data;
        dispatch({
          type: 'snackBar/ADD',
          payload: {
            severity: 'error',
            message: `${errorDescription ? errorDescription : message?.detail ?? axiosError.message}`,
          },
        });
      }
    } else {
      dispatch({
        type: 'snackBar/ADD',
        payload: {
          severity: 'error',
          message: `${errorDescription ? `${errorDescription} ` : ''}${error.message}`,
        },
      });
    }
    console.log(error);
    throw error;
  }
}
